var _style, _g, _polyline;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);stroke:#AFAFAF;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st1{fill:url(#SVGID_00000100379518538195064580000014064187464790324155_);stroke:#1D1D1B;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st2{fill:url(#SVGID_00000034783520784795637350000014944318377314898583_);stroke:#AFAFAF;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st3{fill:url(#SVGID_00000025441977145564581340000013668149761284819620_);stroke:#AFAFAF;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st4{fill:url(#SVGID_00000029024135055272926880000006884939868375206835_);stroke:#AFAFAF;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st5{fill:url(#SVGID_00000136392748040130975090000015278988290334877590_);stroke:#AFAFAF;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.1119,
    y1: 7.0285,
    x2: 14.8993,
    y2: 7.0285,
    gradientTransform: "matrix(1 0 0 -1 0 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDB28"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.1,18.2 3.1,25.4 14.9,31.5 14.9,19.1 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172441446876762206240000008564669016440940718_",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: 19.39,
    x2: 26.9,
    y2: 19.39,
    gradientTransform: "matrix(1 0 0 -1 0 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDB28"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000172441446876762206240000008564669016440940718_)",
      stroke: "#1D1D1B",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: " 15.8,16.9 4,11.7 17,8.1 26.9,11.9 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172421365767842639150000011957343453739039123_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4384,
    y1: 17.7276,
    x2: 30.9607,
    y2: 17.7276,
    gradientTransform: "matrix(1 0 0 -1 0 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDB28"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000172421365767842639150000011957343453739039123_)",
      stroke: "#AFAFAF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: " 15.8,16.9 20.1,23.6 30.3,17.9 26.9,11.9 31,8.1 21.3,4.7 17,8.1 13.3,5.1 0.8,8.5 4,11.7 0.5,16.9 13,23.2 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130625673303416791810000015506054337509482626_",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: 19.39,
    x2: 26.9,
    y2: 19.39,
    gradientTransform: "matrix(1 0 0 -1 0 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDB28"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000130625673303416791810000015506054337509482626_)",
      stroke: "#AFAFAF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: " 4,11.7 15.8,16.9 26.9,11.9 17,8.1 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067209818380754825860000017960140055682650021_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.8,
    y1: 19.39,
    x2: 26.9201,
    y2: 19.39,
    gradientTransform: "matrix(1 0 0 -1 0 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDB28"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000067209818380754825860000017960140055682650021_)",
      stroke: "#AFAFAF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: " 17,8.1 15.8,16.9 26.9,11.9 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101805728129688044770000007270405817371527561_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.0195,
    y1: 7.69,
    x2: 14.8488,
    y2: 7.69,
    gradientTransform: "matrix(1 0 0 -1 0 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDB28"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000101805728129688044770000007270405817371527561_)",
      stroke: "#AFAFAF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: " 26,20.6 20.1,23.6 15.8,16.9 14.8,19 14.9,31.5 26,26.6 26,20.6 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox3);
export default __webpack_public_path__ + "static/media/box3.cbdadd70ac5d4c79e2952722a48ef151.svg";
export { ForwardRef as ReactComponent };